import React, { useState } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { Accordion, AccordionTheme } from 'wix-ui-tpa/cssVars';
import { SingleSlotDetailsDataHook } from './dataHooks';
import { classes, st } from './MoreDetails.st.css';

export type ExpandableDetailsProps = {
  children: React.ReactNode;
  className?: string;
  /** Distinguishes the accordion item when a page renders more than one toggle. */
  id?: string;
};

/**
 * "More details" / "Less details" toggle. The content is rendered above the toggle while
 * expanded (so the toggle stays at the bottom) and inside the collapsed accordion item
 * otherwise, which keeps the accordion's open/close animation.
 */
export const ExpandableDetails: React.FC<ExpandableDetailsProps> = ({
  children,
  className,
  id = 'more-details-section',
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      {isExpanded && children}
      <Accordion
        className={st(classes.accordion, {}, className)}
        data-hook={SingleSlotDetailsDataHook.MORE_DETAILS_ACCORDION}
        onItemClick={(_id: string, isItemExpanded: boolean) =>
          setIsExpanded(isItemExpanded)
        }
      >
        <Accordion.Item
          id={id}
          title={t(
            isExpanded
              ? 'app.bookings-form.bookings-details.less-details.title'
              : 'app.bookings-form.bookings-details.more-details',
          )}
          theme={AccordionTheme.Line}
        >
          {!isExpanded && children}
        </Accordion.Item>
      </Accordion>
    </>
  );
};
